export const busOperatorReducerSelector = state => state.busOperatorReducer;
